import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-022294c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TwoFactorWizardstep-size-security data--center" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "validation__error"
}
const _hoisted_4 = {
  key: 1,
  class: "validation__error"
}
const _hoisted_5 = {
  key: 2,
  class: "validation__error"
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "sat.solar.energy@ingeteam.com", -1))
const _hoisted_8 = { class: "flex__separate05" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "section--column--center",
    onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toValidate && _ctx.toValidate(...args)), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.Validate')), 1),
      _withDirectives(_createElementVNode("input", {
        required: "",
        type: "text",
        pattern: "\\d*",
        minlength: "6",
        maxlength: "6",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validationCode) = $event)),
        onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeyPress && _ctx.handleKeyPress(...args))),
        disabled: !_ctx.isPossibleValidate,
        ref: "validationCodeRef"
      }, null, 40, _hoisted_2), [
        [_vModelText, _ctx.validationCode]
      ]),
      (_ctx.isInvalidCodeL1)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('TwoFactorAuth.ValidCodeNoValid1')), 1))
        : _createCommentVNode("", true),
      (_ctx.isInvalidCodeL2)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('TwoFactorAuth.ValidCodeNoValid2')), 1))
        : _createCommentVNode("", true),
      (_ctx.isInvalidCodeL2)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('TwoFactorAuth.ValidCodeNoValid3')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.errorDateCountdown), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isInvalidCodeL2)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('TwoFactorAuth.isInvalidCodeL2Question')) + " " + _toDisplayString(_ctx.$t('TwoFactorAuth.isInvalidCodeL2ContactSupport')) + ": ", 1),
            _hoisted_7
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isPossibleValidate && _ctx.isSecurityUrl)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toBack && _ctx.toBack(...args))),
            class: "btn btn-primary p-x-2 border__rounded btn-2fa"
          }, _toDisplayString(_ctx.$t('wizard.previous')), 1))
        : _createCommentVNode("", true),
      (_ctx.isPossibleValidate)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toValidate && _ctx.toValidate(...args))),
            disabled: !_ctx.isValidationCodeValid,
            class: "btn btn-primary p-x-2 border__rounded btn-2fa"
          }, _toDisplayString(_ctx.$t('wizard.validate')), 9, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 32))
}